import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

import Home from './user/pages/Home';
import About from './user/pages/About';
import Category from './user/pages/Category';
import Blog from './user/pages/Blog';
import AllBlogs from './user/pages/AllBlogs';
import Contact from './user/pages/Contact';
import UserLogin from './user/pages/UserLogin';
import UserSignup from './user/pages/UserSignup';
import MyBlogs from './user/pages/MyBlogs';
import CreateBlogs from './user/pages/CreateBlogs';
import Product from './user/pages/Product';
import ProductSlug from './user/pages/ProductSlug';
import Checkout from './user/pages/Checkout';
 import AccountOrder from "./user/pages/account/AccountOrder";
import AccountOrderView from "./user/pages/account/AccountOrderView";
import Accountprofile from "./user/pages/account/Accountprofile";
import AccountPassword from "./user/pages/account/AccountPassword";
import AccountSupport from "./user/pages/account/AccountSupport";
import AccountPlan from "./user/pages/account/AccountPlan";
import Account from "./user/pages/account/Account";

import CartPage from './user/pages/Cart';
import CompleteOrder from './user/pages/CompleteOrder';
import WishList from './user/pages/WishList';
import Comparsion from './user/pages/Comparsion';
import Page from './user/pages/Page';
import Cancel from './user/pages/Cancel';

import ErrorPage from './user/pages/ErrorPage';

import { Toaster } from "react-hot-toast";

import { BlogProvider } from './fetchdata/BlogContext';

import usePreventZoom from './helper/usePreventZoom';
import getCookie from './user/components/extra/getCookie';
import getDecryptData from "./helper/getDecryptData";
import HomeNew from './user/pages/HomeNew';



const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};


function App() {


  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        setisUsertype(mydatatype);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

    return (
    <>
      <BlogProvider>
        <Toaster />

        <Routes>

          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/404" element={<ErrorPage />} />

          <Route path="/allblogs" element={<AllBlogs />} />
          {/* <Route path="/login" element={<UserSignup updateAuthStatus={setIsUserAuthenticated} />} />
          <Route path="/signup" element={<UserSignup />} /> */}

              <Route
            path="/login"
            element={    isUserAuthenticated ? <Account /> :<UserLogin updateAuthStatus={setIsUserAuthenticated} /> 
          }
          />
          

          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/page/:slug" element={<Page />} />
          <Route path="/category/:id" element={<Category />} />
          <Route path="/product/:id" element={<Product />} />
          <Route path="/product/:slug/:id" element={<ProductSlug />} />

          <Route path="/checkout" element={<Checkout updateAuthStatus={setIsUserAuthenticated} />} />
          <Route path="/cart" element={<CartPage />} />
          {/* <Route path="/complete-order" element={isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />} /> */}

          <Route path="/complete-order" element={  isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />}/>


          <Route path="/wishList" element={isUserAuthenticated ? <WishList /> : <Navigate to="/login" />} />

          <Route path="/comparsion" element={isUserAuthenticated ? <Comparsion /> : <Navigate to="/login" />} />

     

        <Route
            path="/account"
            element={
              isUserAuthenticated ? <Account /> : <Navigate to="/login" />
            }
          />
          <Route
            path="/account/order/:userId/:orderId"
            element={
              isUserAuthenticated ? (
                <AccountOrderView />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

            <Route
            path="/account/orders"
            element={
              isUserAuthenticated ? (
                <AccountOrder />
              ) : (
                <Navigate to="/login" />
              )
            }
          />


          <Route path="/account/plan"
            element={
              isUserAuthenticated ? (
                <AccountPlan />
              ) : (
                <Navigate to="/login" />
              )

            }
          />


          <Route
            path="/account/profile"
            element={
              isUserAuthenticated ? (
                <Accountprofile />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          
          <Route
            path="/account/password"
            element={
              isUserAuthenticated ? (
                <AccountPassword />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/account/support"
            element={
              isUserAuthenticated ? (
                <AccountSupport />
              ) : (
                <Navigate to="/login" />
              )
            }
          />


          <Route path="/cancel" element={<Cancel/>} />

          
          <Route path="/" element={<HomeNew />} />
          <Route path="/old" element={<Home />} />

          <Route path="*" element={<ErrorPage />} />


        </Routes>
        <ScrollToTop />
      </BlogProvider>
    </>
  );
}

export default App;
